/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Link, Typography, useTheme } from '@zapier/design-system';

type Props = {
  /**
   * Array of links to render.
   */
  links: Array<{ text: string; href: string }>;
};

// See note in .md file.
export const CssVars = {
  flexDirection: '--UniversalFooter__HelpfulLinks-flex-direction',
  justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};

const Styles = {
  root: (isRebrand: boolean) => css`
    display: flex;
    flex-direction: var(${CssVars.flexDirection}, column);
    justify-content: var(${CssVars.justifyContent}, center);
    text-align: center;
    flex-wrap: wrap;
    column-gap: ${isRebrand ? '12.5px' : '15px'};
    row-gap: ${isRebrand ? '10px' : '5px'};
  `,
  link: (isRebrand: boolean) => css`
    ${Typography.paragraph3Semibold};
    color: ${isRebrand ? Colors.neutral700 : Colors.gray60} !important;
    // For browsers that don't yet support Flexbox gap
    padding: 0 5px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${isRebrand ? Colors.blue : Colors.ocean} !important;
      outline: none;
    }
  `,
};

/**
 * @private
 * Links to common pages that may not render in the main navigation.
 */
export const HelpfulLinks = (props: Props) => {
  const { isRebrand } = useTheme();

  const linkNodes = props.links.map((link) => {
    return (
      <li key={link.text}>
        <Link color={null} css={Styles.link(isRebrand)} href={link.href}>
          {link.text}
        </Link>
      </li>
    );
  });

  return <ul css={Styles.root(isRebrand)}>{linkNodes}</ul>;
};

HelpfulLinks.defaultProps = {
  links: [
    { text: 'Pricing', href: '/pricing' },
    { text: 'Help', href: '/help' },
    { text: 'Developer Platform', href: '/platform' },
    { text: 'Press', href: '/press' },
    { text: 'Jobs', href: '/jobs/' },
    { text: 'Zapier for Companies', href: '/companies' },
    { text: 'Transfer', href: '/transfer' },
  ],
};
